import { useState } from 'react';
import { ModuleDataHandler } from '../helpers/handleReportCalc';
import TBodyRow from './TBodyRow';
import { useQuery } from '../../../../hooks/UseQuery';
interface IProps {
  moduleData: any;
  numberOfDay: any;
  isView: boolean;
}

const TBody = ({ moduleData, isView, numberOfDay }: IProps) => {
  const employee_name = useQuery('employee_name');
  const [render, setRender] = useState<boolean>(false);
  return (
    <tbody>
      {moduleData?.list?.length > 0 &&
        moduleData?.list?.map((item: any, index: number) => (
          <TBodyRow
            {...{
              moduleData,
              item,
              index,
              isView,
              numberOfDay,
              setRender,
            }}
          />
        ))}
      {moduleData?.list?.length > 0 && (
        <tr>
          <td colSpan={2}>{`${employee_name?.toUpperCase()} TOTALS`}</td>
          <td>{moduleData.total_qty}</td>
          <td>{moduleData.total_rate}</td>
          <td>{moduleData.total_amount}</td>
          <td>{moduleData.total_net_wt}</td>
          <td>{moduleData.total_total_wt}</td>
          <td>{moduleData.total_amt}</td>
        </tr>
      )}
    </tbody>
  );
};

export default TBody;
